import { ApiPseBank, ApiPseData } from '@api/_api/api-payment/api-pse.model';

export class PseModelsTransformer {
    public static PseBanksFromApi(apiPseBanks: ApiPseData): ApiPseBank[] {
        const banks = Object.assign([], apiPseBanks.banks);
        return banks;
    }
}
